/*
<summary>
  This functional component "ChangePassword" defines the props like initial values and functions for the child form
  component.
  Developer:Aashish Singh, Created Date:29-August-2023
</summary>
<returns>Returns JSX</returns>
*/

import base64 from 'base-64';
import { observer } from 'mobx-react';
import React, { useEffect } from 'react';
import toast from 'react-hot-toast';
// import { initialStateUpdatePassword } from "../../../core/initial-state/change-password-state";
import { useStore } from '../../../../contexts/store-provider';
import { ChangePasswordInitalState } from '../../../../core/initialState';
import { IChangePassword } from '../../../../models/forms/IChangePassword';
import { IFormModalProps } from '../../../../models/forms/IForm';
import { formatMessage } from '../../../../translations/format-message';
import ChangePasswordForm from '../../forms/change-password-form';

let ChangePassword: React.FC<IFormModalProps> = (props) => {
  const { userStore } = useStore();
  const {
    UpdatePasswordServiceNew,
    changePasswordStateNew,
    resetChangePasswordNew,
  } = userStore;

  /**
   * The useEffect Hook lets you perform side effects in function component.
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "changePasswordSuccess" of the useEffect changed.
   */
  useEffect(() => {
    if (changePasswordStateNew.success) {
      toast.success(formatMessage('updated_success'));
      onModalClosed();
    }
  }, [changePasswordStateNew.success]);

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "changePasswordError" of the useEffect changed.
   */
  useEffect(() => {
    if (changePasswordStateNew.error) {
      toast.error(formatMessage(changePasswordStateNew.error));
      resetChangePasswordNew();
    }
  }, [changePasswordStateNew.error]);

  /**
   * This function changes the user password by provides new password and user Id  to "chagePassword" store funtion that
   * send the request to Api.
   */
  const onSubmitForm = (values: IChangePassword) => {
    let submitData: IChangePassword;
    submitData = {
      UserId: props.id,
      NewPassword: base64.encode(values.NewPassword),
    };
    UpdatePasswordServiceNew(submitData);
  };

  /**
   * This function closes the pop up modal and reset ChangePassword observables (success, inprogress and error).
   */
  const onModalClosed = () => {
    resetChangePasswordNew();
    props.modalClosed();
  };

  return (
    <ChangePasswordForm
      id={props.id}
      // initialValues={initialStateUpdatePassword}
      initialValues={ChangePasswordInitalState}
      submitHandler={onSubmitForm}
      onModalClosed={onModalClosed}
      isLoading={changePasswordStateNew.inProgress}
    />
  );
};

export default observer(ChangePassword);
